var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
var symboll = window.shop_symbol;
if (document.querySelector('[name="country_code"]') != null) {
  symboll = document.querySelector('[name="country_code"]').getAttribute("symbol");
}

if (document.querySelector('.template--cart')) {
  var currentItemCount = Array.from(document.querySelector('.template--cart').querySelectorAll('[name="updates[]"]'))
    .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
} else {
  var currentItemCount = Array.from(document.querySelector('.cart-drawer')?.querySelectorAll('[name="quantity"]') || [])
    .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
}

Shopify.money_format = symboll + "{{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";
    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

var languageRoot = Shopify.routes.root;
var languageRootRemovedLastSlash = languageRoot.slice(0, languageRoot.length - 1);

const cartItem = `<div data-product="%VARIANT_ID%" data-gift-product="%giftProduct%" class="columns is-multiline is-mobile is-marginless cart-drawer__products item-%PRODUCT_ID% shopItem">
      <div class="column is-4-desktop is-4-tablet is-3-mobile productImage">
          <a href="${languageRootRemovedLastSlash}/products/%HANDLE%" aria-label="Product link">%PRODUCT_IMAGE%</a>
      </div>
      <div class="column is-8-desktop is-8-tablet is-8-mobile">
        <div class="cart__drawer--title">
          <a href="${languageRootRemovedLastSlash}/products/%HANDLE%" aria-label="Product Title" tabindex="0"
          class="margin-b-10 margin-b-10 product-title" tabindex="0">%PRODUCT_TITLE%</a>
          <div class="product-option">
            <span class="option-label">%OPTION_LABEL_1%</span>
            <p class="select__variant">%SELECTED_VARIANT_1%</p>
          </div>
          <div class="product-option">
            <span class="option-label">%OPTION_LABEL_2%</span>
            <p class="select__variant">%SELECTED_VARIANT_2%</p>
          </div>
          <div class="product-option">
            <span class="option-label">%OPTION_LABEL_3%</span>
            <p class="select__variant">%SELECTED_VARIANT_3%</p>
          </div>
          <p class="selling-plan"></p>
          <p class="product-price %PRODUCT_STATE%">
          <span class="price-item price-item--sale ">%FINAL_PRICE%</span> 
          <span class="price-item price-item--regular money" style="display:none">%COMPARE_PRICE%</span>
          </p>
          <div class="unit_price" unit_price>%UNIT_PRICE%</div>
        </div>
          <div class="form-field form-options js-required">

          <div class="product-form__input product-form__quantity">
           <div class="quantity__main quantity__main-cart">
              <button class="quantity_button quantity__decrease" name="minus">
                <span>-</span>
              </button>
              <div class="quantity_button quantity_num">
                <input id="quantity" name="quantity" type="number" min="1" value="%ITEM-QUANTITY%" variant_id="%PRODUCT_ID%">
              </div>
              <button class="quantity_button quantity__increase" name="plus">
                <span>+</span>
              </button>
            </div>
            <div class="cart-item__error" id="Line-item-error-%PRODUCT_ID%" role="alert">
            <small class="cart-item__error-text"></small>
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
              <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>
              <circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"/>
              <path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"/>
              <path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7">
            </svg>
          </div>
          </div>
          </div>
          <a href="javascript:void(0)" onClick="removeItem(%VARIANT_ID%);" class="is-marginless removeItem">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M2 6H18V19C18 19.2652 17.8946 19.5196 17.7071 19.7071C17.5196 19.8946 17.2652 20 17 20H3C2.73478 20 2.48043 19.8946 2.29289 19.7071C2.10536 19.5196 2 19.2652 2 19V6ZM4 8V18H16V8H4ZM7 10H9V16H7V10ZM11 10H13V16H11V10ZM5 3V1C5 0.734784 5.10536 0.48043 5.29289 0.292893C5.48043 0.105357 5.73478 0 6 0H14C14.2652 0 14.5196 0.105357 14.7071 0.292893C14.8946 0.48043 15 0.734784 15 1V3H20V5H0V3H5ZM7 2V3H13V2H7Z" fill="#DB5858"/>
            </svg>
          </a>
      </div>
  </div>`;

var isOpen = false;
var addedSuggested = 0;
var timer;

// Add to cart intercept (drawer)
document.addEventListener("click", (event) => {
  var clickedAtcButton = event.target.closest('.add-to-cart-btn') || event.target.closest('.product-form__submit');
  if (!clickedAtcButton) return;

  if (window.settings.cartType === "cart-drawer") {
    event.preventDefault();

    var self = clickedAtcButton;
    var product_id = self.getAttribute('product_id');
    var metaf = self.getAttribute('metaf');
    var data = new FormData(self.closest("form"));

    addProductToCart(product_id, metaf, product_id, data);
  }
});

const cartDrawer = document.querySelector('.cart-drawer');

// CLICK qty buttons (drawer) - guard
if (cartDrawer) {
  cartDrawer.addEventListener("click", (event) => {
    var clickedQuantityButton = event.target.closest('.quantity__main button');
    if (!clickedQuantityButton) return;

    event.preventDefault();
    var quantityWrapper = event.target.closest('.quantity__main');
    var quantityInput = quantityWrapper.querySelector('input[type="number"]');

    var currentValue = quantityInput.value;

    if (clickedQuantityButton.getAttribute('name') == 'plus') {
      currentValue = parseFloat(currentValue) + 1;
    } else if (clickedQuantityButton.getAttribute('name') == 'minus') {
      if (currentValue > 0) {
        currentValue = parseFloat(currentValue) - 1;
      }
    }

    document.querySelectorAll('.quantity_button').forEach(el => el.setAttribute('disabled', 'disabled'));
    setTimeout(function () {
      testQty(quantityWrapper.querySelector('[name="quantity"]').getAttribute('variant_id'), currentValue);
    }, 50);
  });

  // CHANGE manual input (drawer)
  cartDrawer.addEventListener("change", (event) => {
    const changedQuantityElement = event.target.closest('[name="quantity"]');
    if (!changedQuantityElement) return;

    event.preventDefault();
    var currentValue = changedQuantityElement.value;
    setTimeout(function () {
      testQty(changedQuantityElement.getAttribute("variant_id"), currentValue);
    }, 50);
  });
}

function addProductToCart(formID, metafields, productID, target) {
  window.localStorage.setItem("timer", new Date().getTime() + 10 * 60 * 1000);

  fetch(window.routes.cart_add_url + '.js', {
    body: target,
    headers: {
      'X-Requested-With': 'xmlhttprequest'
    },
    method: 'POST'
  }).then(function (response) {
    return response.json();
  })
    .then(function addProductToCartSuccess(response) {
      if (response.status) {
        handleErrorMessage(response.description);
        return;
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: response.currency || window.Shopify?.currency?.active || 'EUR',
          value: (response.price / 100) * (response.quantity || 1),
          items: [{
            item_id: response.variant_id?.toString(),
            item_name: response.product_title,
            item_brand: response.vendor,
            item_variant: response.variant_title,
            price: response.price / 100,
            quantity: response.quantity || 1
          }]
        }
      });

      // gift wrap code
      var productOrQuickViewWrapper = document.querySelector('.quick-view_grid') || document.querySelector('.product__detail');

      if (productOrQuickViewWrapper &&
          productOrQuickViewWrapper.querySelector('.product__wrapping') &&
          productOrQuickViewWrapper.querySelector('#add_gift_wrapping') &&
          productOrQuickViewWrapper.querySelector('#add_gift_wrapping').checked == true) {

        var gift_wrapping_container = productOrQuickViewWrapper.querySelector('.product__wrapping');
        var gift_wrapping_id = gift_wrapping_container.dataset.giftId;
        var message = gift_wrapping_container.querySelector("textarea").value;
        var product = gift_wrapping_container.dataset.giftProduct;

        var gift = {
          id: gift_wrapping_id,
          quantity: 1,
          properties: {
            _gift_wrapping_message: message,
            _gift_wrapping_product: product,
          },
        };

        var data = { items: [] };
        data["items"].push(gift);

        fetch(window.routes.cart_add_url + '.js', {
          body: JSON.stringify(data),
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
          },
          method: 'POST'
        }).then(function (response) {
          return response.json();
        })
          .then(function addProductToCartSuccess(response) {
            addToCartOk(response);
          });
      } else {
        addToCartOk(response);
      }
    })
    .catch(function errorHandler(error) {
      console.warn('Something went wrong with store.js addProductToCart.', error);
    });

  if (metafields != "") {
    window.localStorage.setItem("metafields-" + productID, metafields);
  }
  return false;
}

function handleErrorMessage(errorMessage = false) {
  let errorMessageWrapper = document.querySelector('.product-form__error-message-wrapper');
  if (!errorMessageWrapper) return;

  let this_errorMessage = errorMessageWrapper.querySelector('.product-form__error-message');
  errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

  if (errorMessage && this_errorMessage) {
    this_errorMessage.textContent = errorMessage;
  }
}

function testQty(itemID, value) {
  if (value != "Dummy") {
    changeItem(itemID, value);
  }
}

function fetchCart(line) {
  fetch(window.routes.cart_url + '.js')
    .then((response) => response.json())
    .then((response) => {
      var cart = response;
      onCartUpdate(cart);
      renderCart(cart, line);
    });
}

function changeItem(line, quantity, callback) {
  if (isNotLoading()) {
    startLoading();
  }

  var data = {};
  data['id'] = line.toString();
  data['quantity'] = quantity;

  fetch(window.routes.cart_change_url + ".js", {
    method: "POST",
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      if (document.body.classList.contains('template--cart')) {
        const container = document.querySelector('.cart-page');
        const textwrapper = container?.querySelector(`#Line-item-error-${line} .cart-item__error-text`);

        if (textwrapper) {
          if (currentItemCount === cart.item_count) {
            var q = '';
            for (let index = 0; index < cart.items.length; index++) {
              const item = cart.items[index];
              if (item.id === line * 1) q = item.quantity;
            }
            const text = window.cartStrings.quantityError.replace('[quantity]', q);
            textwrapper.textContent = text;
          } else {
            textwrapper.textContent = '';
          }
        }

        document.querySelectorAll('.quantity_button').forEach(el => el.removeAttribute('disabled'));
        currentItemCount = cart.item_count;

        if (!!document.querySelector('.products-cart')) {
          document.querySelectorAll('.products-cart').forEach(function (productElem) {
            var elementRemove = 0;
            var elementId = productElem.dataset.idCart;
            cart.items.forEach(function (elem) {
              if (elem.id == elementId) { elementRemove = 1; }
            });
            if (elementRemove == 0) productElem.remove();
          });
        }

        cart.items.forEach(function (item) {
          if (!!document.querySelector('[data-id-cart="' + item.id + '"]')) {
            var cartItemElem = document.querySelector('[data-id-cart="' + item.id + '"]');
            var cross_new = parseFloat(item.price) * parseFloat(item.quantity);

            cartItemElem.querySelector('.product-price-cart .price-cart').innerText = Shopify.formatMoney(item.final_price);

            if (!!cartItemElem.querySelector('.product-line-price del.cart-item__old-price')) {
              cartItemElem.querySelector('.product-line-price del.cart-item__old-price').innerText = Shopify.formatMoney(cross_new);
            }

            cartItemElem.querySelector('.product-line-price span').innerText = Shopify.formatMoney(item.final_line_price);
            cartItemElem.querySelector('[name="quantity"]').value = item.quantity;
            cartItemElem.querySelector('[name="quantity"]').setAttribute("value", item.quantity);
          }
        });

        if (!!document.querySelector('p.totals__subtotal-value')) {
          document.querySelector('p.totals__subtotal-value').innerText = Shopify.formatMoney(cart.total_price) + ' ' + Shopify.currency.active;
        }
      }

      if (typeof callback === "function") {
        callback(cart);
      } else {
        onCartUpdate(cart);
        fetchCart(line);
      }

      if (cart.item_count < 1) {
        if (!!document.querySelector('.cart-page')) {
          document.querySelector('.cart-page').innerHTML = `<div class="cart__warnings"> <h2 class="cart__empty-text">Your cart is empty</h2> <a href="${window.routes.collection_url}" class="link button button--primary"> Continue shopping </a> </div>`;
        }
      }
    })
    .catch(function (error) {
      console.warn(error);
    });
}

function replaceAll(str, find, replace) {
  return str.replace(new RegExp(find, "g"), replace);
}

function removeItem(itemID) {
  if (!!document.querySelector(".item-" + itemID)) {
    changeItem(itemID, 0);
    document.querySelector(".item-" + itemID).remove();
  } else {
    // fallback: svejedno promijeni u cartu
    changeItem(itemID, 0);
  }
}

function onCartUpdate(cart) {
  // Do nothing, logic handled before render
}

function addToCartOk(product) {
  if (isNotLoading()) startLoading();
  if (!isCartOpen()) openCart();
  setTimeout(() => fetchCart(), 300);
}

function addToCartFail() {
  console.warn("Error adding to cart: -------------------");
}

function renderCart(cart, line) {
  var container = document.querySelector('.cart-drawer');
  const cartItemHolder = document.querySelector('.cart-drawer__cart');

  if (!cartItemHolder) return;

  if (cart.items.length != 0) {
    document.querySelector('.cartEmptyHolder')?.classList.add('is-hidden');
    document.querySelector('.cartItemHolder')?.classList.remove('is-hidden');
  } else {
    document.querySelector('.cartEmptyHolder')?.classList.remove('is-hidden');
    document.querySelector('.cartItemHolder')?.classList.add('is-hidden');
  }

  if (!!document.querySelector('.header-cart-count')) {
    if (cart.item_count > 0) {
      document.querySelector('.header-cart-count').closest('.cart-count-bubble').style.display = "flex";
    } else {
      document.querySelector('.header-cart-count').closest('.cart-count-bubble').style.display = "none";
    }
    document.querySelector('.header-cart-count').innerText = cart.item_count;
  }

  document.querySelectorAll('.shopItem').forEach(function (shopItem) {
    shopItem.remove();
  });

  cart.items.forEach(function (item) {
    var productHandle = item.url.split('?')[0];
    var compare_price = '';

    fetch(productHandle + '.js')
      .then(res => res.json())
      .then(function (prod) {
        var _indx = prod.variants.findIndex(function (x) {
          return x.id == item.id;
        });
        compare_price = prod.variants[_indx]?.compare_at_price;

        var selector = ".item-" + item.id;
        var cartItemElem = document.querySelector(selector);
        if (!cartItemElem) return;

        if (compare_price != "" && compare_price != null) {
          var reg = cartItemElem.querySelector('p.product-price.price--on-regular span.price-item.price-item--regular.money');
          if (reg) {
            reg.innerText = Shopify.formatMoney(compare_price);
            reg.style.display = 'inline-block';
          }
        } else {
          var discount_price = item.discounted_price;
          var original_price = item.price;
          if (original_price != discount_price) {
            compare_price = original_price;
            var reg2 = cartItemElem.querySelector('p.product-price.price--on-regular span.price-item.price-item--regular.money');
            if (reg2) {
              reg2.innerText = Shopify.formatMoney(compare_price);
              reg2.style.display = 'inline-block';
            }
          }
        }
      })
      .catch(function () {
        console.warn('Something went wrong: error fetching products in store.js fetchCart');
      });

    var subtotal = "" + Shopify.formatMoney(cart.items_subtotal_price);
    var discounted_cal = parseFloat(cart.original_total_price) - parseFloat(cart.items_subtotal_price);
    var discounted_amount = "" + Shopify.formatMoney(discounted_cal);
    var cost2 = "" + Shopify.formatMoney(item.discounted_price);

    var unit_price_referal = "";
    if (item.unit_price != undefined) {
      var unit_price = Shopify.formatMoney(item.unit_price);
      var referal_unit = "";
      if (item.unit_price_measurement.reference_value != 1) {
        referal_unit = item.unit_price_measurement.reference_value + item.unit_price_measurement.reference_unit;
      } else {
        referal_unit = item.unit_price_measurement.reference_unit;
      }
      unit_price_referal = unit_price + " / " + referal_unit;
    }

    var _imgr = "";
    if (item.image != null) {
      var img_tag_src = item.image
        .replace(".png", "_170x170_crop_center.png")
        .replace(".jpg", "_170x170_crop_center.jpg");
      _imgr = '<img src="' + img_tag_src + '" loading="lazy" alt="product" />';
    } else {
  _imgr = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" class="has-background-light" aria-hidden="true">
      <rect x="4" y="4" width="56" height="56" rx="6" ry="6" fill="#f3f3f3"/>
      <circle cx="24" cy="26" r="6" fill="#d0d0d0"/>
      <path d="M10 50l14-14 10 10 8-8 12 12" fill="none" stroke="#b0b0b0" stroke-width="2"/>
    </svg>
  `;
}


    var cartItem2 = replaceAll(cartItem, "%PRODUCT_TITLE%", item.product_title);
    cartItem2 = replaceAll(cartItem2, "%PRODUCT_IMAGE%", _imgr);
    cartItem2 = replaceAll(cartItem2, "%PRODUCT_STATE%", "price--on-regular");
    cartItem2 = replaceAll(cartItem2, "%FINAL_PRICE%", cost2);
    cartItem2 = replaceAll(cartItem2, "%UNIT_PRICE%", unit_price_referal);

    if (compare_price > 0) {
      cartItem2 = replaceAll(cartItem2, "%COMPARE_PRICE%", Shopify.formatMoney(compare_price));
    }

    cartItem2 = replaceAll(cartItem2, "%ITEM-QUANTITY%", item.quantity);

    if (item.variant_options[0] != "Default Title") {
      cartItem2 = replaceAll(cartItem2, "%SELECTED_VARIANT_1%", item.options_with_values[0]?.value || " ");
      cartItem2 = replaceAll(cartItem2, "%SELECTED_VARIANT_2%", item.options_with_values[1]?.value || " ");
      cartItem2 = replaceAll(cartItem2, "%SELECTED_VARIANT_3%", item.options_with_values[2]?.value || " ");

      cartItem2 = replaceAll(cartItem2, "%OPTION_LABEL_1%", (item.options_with_values[0]?.name ? item.options_with_values[0]?.name + ":" : " "));
      cartItem2 = replaceAll(cartItem2, "%OPTION_LABEL_2%", (item.options_with_values[1]?.name ? item.options_with_values[1]?.name + ":" : " "));
      cartItem2 = replaceAll(cartItem2, "%OPTION_LABEL_3%", (item.options_with_values[2]?.name ? item.options_with_values[2]?.name + ":" : " "));
    } else {
      cartItem2 = replaceAll(cartItem2, "%OPTION_LABEL_1%", " ");
      cartItem2 = replaceAll(cartItem2, "%OPTION_LABEL_2%", " ");
      cartItem2 = replaceAll(cartItem2, "%OPTION_LABEL_3%", " ");
      cartItem2 = replaceAll(cartItem2, "%SELECTED_VARIANT_1%", " ");
      cartItem2 = replaceAll(cartItem2, "%SELECTED_VARIANT_2%", " ");
      cartItem2 = replaceAll(cartItem2, "%SELECTED_VARIANT_3%", " ");
    }

    cartItem2 = replaceAll(cartItem2, "%PRODUCT_ID%", item.id);
    cartItem2 = replaceAll(cartItem2, "%VARIANT_ID%", item.variant_id);
    cartItem2 = replaceAll(cartItem2, "%HANDLE%", item.handle);

    if (item.properties && item.properties._gift_wrapping_product) {
      cartItem2 = replaceAll(cartItem2, "%giftProduct%", item.properties._gift_wrapping_product);
    } else {
      cartItem2 = replaceAll(cartItem2, "%giftProduct%", "");
    }

    var cartParser = new DOMParser();
    var cartDocument = cartParser.parseFromString(cartItem2, "text/html");
    var cartHtml = cartDocument.querySelector('.cart-drawer__products');
    if (cartHtml) cartItemHolder.prepend(cartHtml);

    // ✅ selling plan fix
    var itemElement = document.querySelector(`.item-${item.id}`);
    if (itemElement && item.selling_plan_allocation != undefined) {
      itemElement.querySelector(`p.selling-plan`).innerText = item.selling_plan_allocation.selling_plan.name;
    }

    if (!!document.querySelector('.items_subtotal')) {
      document.querySelector('.items_subtotal').innerText = subtotal;
    }

    var symboll2 = window.shop_symbol;
    if (document.querySelector('[name="country_code"]') != null) {
      symboll2 = document.querySelector('[name="country_code"]').getAttribute("symbol");
    }
    var vlue_zero = symboll2 + "0.00";

    if (discounted_amount != vlue_zero) {
      document.querySelector('.disocunt_calculate p') && (document.querySelector('.disocunt_calculate p').innerText = discounted_amount);
    } else {
      document.querySelector('.disocunt_calculate p') && (document.querySelector('.disocunt_calculate p').innerText = window.cartStrings.discount_policy);
    }
  });

  var text = document.querySelector('.view_cart-btn')?.innerText;
  if (text) {
    var new_text = text.replace(/\(.*?\)/g, '(' + cart.item_count + ')');
    document.querySelector('.view_cart-btn').innerText = new_text;
  }

  // Error message (drawer)
  if (container && line && container.querySelector(`#Line-item-error-${line}`)?.querySelector('.cart-item__error-text')) {
    var textwrapper = container.querySelector(`#Line-item-error-${line}`).querySelector('.cart-item__error-text');
    if (currentItemCount === cart.item_count) {
      var q = '';
      for (let index = 0; index < cart.items.length; index++) {
        const it = cart.items[index];
        if (it.id === line * 1) q = it.quantity;
      }
      const txt = window.cartStrings.quantityError.replace('[quantity]', q);
      textwrapper.textContent = txt;
    } else {
      textwrapper.textContent = '';
    }
  }

  currentItemCount = cart.item_count;
  stopLoading();
  document.querySelectorAll('.quantity_button').forEach(el => el.removeAttribute('disabled'));
}

function onTidioChatApiReady() {
  setTimeout(function () {
    if (!!document.querySelector('#tidio-chat-iframe')) {
      document.querySelector('#tidio-chat-iframe').style.zIndex = 699;
    }
  }, 500);
}

document.addEventListener("DOMContentLoaded", function () {
  fetchCart();
});

// Drawer open/close
function closeCart() {
  document.documentElement.style.overflowY = 'scroll';
  isOpen = false;
  document.querySelector('.cart-flyout')?.classList.add('is-closing');
  document.querySelector('.cart-flyout')?.classList.remove('is-active');
  document.querySelector('.cartOverlay') && (document.querySelector('.cartOverlay').style.display = 'none');

  setTimeout(function () {
    document.querySelector('.cart-flyout')?.classList.remove('is-closing');
    document.querySelector('.cart-flyout') && (document.querySelector('.cart-flyout').style.display = 'none');
  }, 750);

  if (typeof removeTrapFocus === "function") {
    removeTrapFocus(document.getElementById("cart-icon-bubble"));
  }
}

function openCart() {
  document.documentElement.style.overflowY = 'hidden';
  isOpen = true;

  if (document.querySelector('.cart-flyout')) {
    document.querySelector('.cart-flyout').style.display = '';
    document.querySelector('.cart-flyout').classList.remove('is-closing');
    document.querySelector('.cart-flyout').classList.add('is-active');
  }

  let drawerCartElem = document.querySelector(".cart-drawer");

  if (drawerCartElem && typeof trapFocus === "function") {
    trapFocus(drawerCartElem, document.querySelector(".cart-drawer__close > button"));
  }

  if (drawerCartElem) {
    drawerCartElem.addEventListener("keyup", function (event) {
      if (event.code == "Escape") closeCart();
    });
  }

  setTimeout(() => document.querySelector('.cartOverlay') && (document.querySelector('.cartOverlay').style.display = 'block'), 50);
}

document.getElementById("cart-icon-bubble")?.addEventListener("click", function (event) {
  if (window.settings.cartType !== "cart-drawer") return;
  event.preventDefault();
  if (!document.body.classList.contains('template--cart')) {
    toggleCart(event);
  }
});

function toggleCart(e) {
  if (e && typeof e.preventDefault === "function") e.preventDefault();
  if (isCartOpen()) {
    closeCart();
    return false;
  } else {
    openCart();
    return false;
  }
}

function isCartOpen() {
  return isOpen;
}

function clickOverlay(e) {
  toggleCart(e || window.event);
}

function addSuggested(formID, metafields, itemID, productID) {
  window.localStorage.setItem("timer", new Date().getTime() + 10 * 60 * 1000);
  if (isNotLoading()) startLoading();
  if (!isCartOpen()) openCart();

  if (!!document.querySelector(`#${productID}Variant`)) {
    itemID = document.querySelector(`#${productID}Variant`).value;
  }

  if (!!document.querySelector(`#${productID}Qty`) && !!document.querySelector(`#${productID}Select`)) {
    document.querySelector(`#${productID}Qty`).setAttribute('value', document.querySelector(`#${productID}Select`).value);
    document.querySelector(`#${productID}Input`).setAttribute('value', itemID);
    addProductToCart(formID, metafields, itemID);
    document.querySelector(`#${productID}Form`).style.display = 'none';
  }
}

function startLoading() {
  document.querySelector('.cartLoader')?.classList.remove('is-hidden');
}
function stopLoading() {
  document.querySelector('.cartLoader')?.classList.add('is-hidden');
}
function isNotLoading() {
  return document.querySelector('.cartLoader')?.classList.contains('is-hidden');
}

function itemTimer(cart) {
  var isSingle = true;
  if (cart.item_count > 1) isSingle = false;

  if (timer || cart.item_count === 0) clearInterval(timer);

  window.localStorage.setItem("timer", new Date().getTime() + 10 * 60 * 1000);
  var countDown = Number(window.localStorage.getItem("timer"));

  if (cart.item_count > 0) {
    timer = setInterval(function () {
      var now = new Date().getTime(),
        distance = countDown - now;

      if (!!document.querySelector('.itemCount')) {
        var itemCount = document.querySelector('.itemCount');
        itemCount.classList.remove('is-hidden');

        if (isSingle) {
          itemCount.innerText = ":" + " " + window.cartItems.cart_count.one.replace("{{ count }}", cart.item_count);
        } else {
          itemCount.innerText = ":" + " " + window.cartItems.cart_count.other.replace("{{ count }}", cart.item_count);
        }

        if (!(distance > 0)) {
          if (isSingle) {
            itemCount.innerText = ":" + " " + window.cartItems.cart_count.one.replace("{{ count }}", cart.item_count);
          } else {
            itemCount.innerText = ":" + " " + window.cartItems.cart_count.other.replace("{{ count }}", cart.item_count);
          }
        }
      }
    }, 1000);
  } else {
    document.querySelector('.itemCount')?.classList.add('is-hidden');
  }
}

// ✅ SINGLE DOMContentLoaded (terms + checkout + color)
document.addEventListener("DOMContentLoaded", function () {

  // Color radio label sync
  document.addEventListener("change", (event) => {
    const changedColorRadio = event.target.closest('[data_options="color"] input[type="radio"]');
    if (!changedColorRadio) return;

    const productFormInput = changedColorRadio.closest('.product-form__input');
    if (productFormInput && productFormInput.querySelector('.form__label span')) {
      productFormInput.querySelector('.form__label span').innerText = changedColorRadio.value;
    }
  });

  // Terms checkbox sync
  var requiresTerms = false;
  if (document.querySelector('.js-cart-terms-checkboxes')) {
    var termsCheckboxes = document.querySelectorAll('.js-cart-terms-checkboxes');
    requiresTerms = true;

    termsCheckboxes.forEach(function (cb) {
      cb.addEventListener('change', function (event) {
        var checkedStatus = event.target.checked;
        termsCheckboxes.forEach(function (x) { x.checked = checkedStatus; });
      });
    });
  }

  // Checkout click handler
  document.querySelectorAll('.cart-drawer__proceed-to-checkout,button.cart__checkout-button.button')
    .forEach(function (checkoutButton) {

      checkoutButton.addEventListener('click', function (e) {
        if (requiresTerms) {
          var terms = document.querySelector('.js-cart-terms-checkboxes');
          if (terms && !terms.checked) {
            alert(window.cartStrings.cartTermsConfirmation);
            e.preventDefault();
            return false;
          }
        }

        e.preventDefault();
        window.location.assign('/checkout');
        return false;
      });
    });

});

// ---------------------------------------------------------
// Variant product card selects (ONLY ONCE)
// ---------------------------------------------------------
class VariantProductcardSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantProductcardChange);
  }

  onVariantProductcardChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateMediaPrice();
    this.closest(".card-wrapper")
      .querySelector('[name="id"]')
      .setAttribute("value", this.currentVariant.id);
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => this.options[index] === option)
        .includes(false);
    });
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateMediaPrice() {
    this.closest(".card-wrapper").querySelector(".price__regular .price-item--regular")
      .innerHTML = `From ${Shopify.formatMoney(this.currentVariant.price)}`;

    if (this.currentVariant.featured_image != null) {
      this.closest(".card-wrapper")
        .querySelector(".primery_card_image")
        .setAttribute("src", this.currentVariant.featured_image.src);
    }
  }
}

class VariantProductcard extends VariantProductcardSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.nextElementSibling.classList.contains('selected')
      ).value;
    });
  }
}

customElements.define("variant-productcard", VariantProductcard);

// Accordion
if (document.querySelector(".accordion-content")) {
  let accordionBtn = document.querySelector(".accordion-btn");
  let accordionContent = document.querySelector(".accordion-content");
  let accordionTextarea = accordionContent?.querySelector("textarea");

  accordionBtn.addEventListener("click", function () {
    accordionBtn.classList.toggle("isOpen");
    toggleAccordionContent();
  });

  accordionBtn.addEventListener("keyup", function (event) {
    if (event.code == "Escape") {
      accordionBtn.classList.remove("isOpen");
      hideAccordionContent();
      event.preventDefault();
    }
  });

  accordionContent.addEventListener("keyup", function (event) {
    if (event.code == "Escape") {
      accordionBtn.classList.remove("isOpen");
      hideAccordionContent();
      event.preventDefault();
    }
  });

  function hideAccordionContent() {
    accordionContent.style.maxHeight = null;
    if (accordionTextarea) accordionTextarea.tabIndex = -1;
    accordionBtn.focus();
  }

  function showAccordionContent() {
    accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
    if (accordionTextarea) accordionTextarea.tabIndex = 0;
    if (accordionTextarea) accordionTextarea.focus();
  }

  function toggleAccordionContent() {
    if (accordionContent.style.maxHeight) hideAccordionContent();
    else showAccordionContent();
  }
}

if (document.getElementById('complementary_slider')) {
  var elem = document.getElementById('complementary_slider');
  var flkty = new Flickity(elem, {
    cellAlign: 'center',
    contain: true
  });
}

if (!!document.querySelector('#CartNote')) {
  document.querySelector('#CartNote').addEventListener('change', debounce((event) => {
    const body = JSON.stringify({ note: event.target.value });
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  }, 300));
}
